import Pagination from 'react-bootstrap/Pagination';

const PaginationButton = ({postsPerPage, totalPosts, paginate}) => {
    const pageNumbers = []
    for (let number = 1; number <= Math.ceil(totalPosts /postsPerPage); number++) {
        pageNumbers.push(
            <Pagination.Item key={number} onClick={() => paginate(number)}>
                {number}
            </Pagination.Item>
        );
    }
  return (
    <Pagination>
        {pageNumbers}
    </Pagination>
  )
}

export default PaginationButton
